<template>
  <el-dialog
    :visible.sync="visible"
    width="480px"
    append-to-body
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="beta-welcome-dialog"
  >
    <div class="beta-welcome">
      <h3 class="beta-welcome__title">{{ $t("beta.welcomeTitle") }}</h3>
      <p class="beta-welcome__intro">{{ $t("beta.welcomeIntro") }}</p>

      <div class="beta-welcome__row">
        <span class="beta-welcome__chip beta-welcome__chip--mint"><i class="el-icon-menu"></i></span>
        <span class="beta-welcome__text">{{ $t("beta.w1") }}</span>
      </div>
      <div class="beta-welcome__row">
        <span class="beta-welcome__chip beta-welcome__chip--info"><i class="el-icon-cpu"></i></span>
        <span class="beta-welcome__text">{{ $t("beta.w2") }}</span>
      </div>
      <div class="beta-welcome__row">
        <span class="beta-welcome__chip beta-welcome__chip--mint"><i class="el-icon-bell"></i></span>
        <span class="beta-welcome__text">{{ $t("beta.w3") }}</span>
      </div>
      <div class="beta-welcome__row">
        <span class="beta-welcome__chip beta-welcome__chip--info"><i class="el-icon-service"></i></span>
        <span class="beta-welcome__text">{{ $t("beta.w4") }}</span>
      </div>

      <button type="button" class="beta-welcome__cta" @click="dismiss">
        {{ $t("beta.welcomeCta") }}
      </button>

      <p class="beta-welcome__note">{{ $t("beta.welcomeNote") }}</p>
    </div>
  </el-dialog>
</template>

<script>
  // 新版 UI 首次进入时的欢迎引导：仅展示一次（localStorage 标记）。
  const SEEN_KEY = "vtm-beta-welcome-seen";

  export default {
    name: "BetaWelcome",
    data() {
      return {
        visible: false
      };
    },
    mounted() {
      if (!localStorage.getItem(SEEN_KEY)) {
        this.visible = true;
        try {
          if (window.Intercom) {
            window.Intercom("trackEvent", "beta_opt_in", {});
          }
        } catch (e) {
          /* ignore */
        }
      }
    },
    methods: {
      dismiss() {
        this.visible = false;
        localStorage.setItem(SEEN_KEY, "1");
      }
    }
  };
</script>

<style scoped lang="scss">
  .beta-welcome {
    padding: 8px 4px 4px;
  }

  .beta-welcome__title {
    margin: 0 0 8px;
    font-family: var(--vtm-display);
    font-size: 20px;
    font-weight: 600;
    color: var(--vtm-heading);
  }

  .beta-welcome__intro {
    margin: 0 0 16px;
    font-size: 13.5px;
    color: var(--vtm-ink-2);
  }

  .beta-welcome__row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }

  .beta-welcome__chip {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    flex-shrink: 0;
    border-radius: var(--vtm-r-md);
    font-size: 16px;
  }

  .beta-welcome__chip--mint {
    background: var(--vtm-mint-soft);
    color: var(--vtm-mint-ink);
  }

  .beta-welcome__chip--info {
    background: var(--vtm-info-soft);
    color: var(--vtm-info);
  }

  .beta-welcome__text {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    color: var(--vtm-ink);
    line-height: 1.5;
  }

  .beta-welcome__cta {
    display: block;
    width: 100%;
    margin-top: 8px;
    padding: 11px 16px;
    border: none;
    border-radius: var(--vtm-r-sm);
    background: var(--vtm-mint);
    color: var(--vtm-navy);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color var(--vtm-speed) ease;

    &:hover {
      background: var(--vtm-mint-dim);
    }

    &:focus-visible {
      outline: 2px solid var(--vtm-mint-dim);
      outline-offset: 1px;
    }
  }

  .beta-welcome__note {
    margin: 12px 0 0;
    text-align: center;
    font-size: 11.5px;
    color: var(--vtm-ink-3);
  }
</style>

<style lang="scss">
  /* el-dialog 挂载在 body 下，需非 scoped 样式覆盖内边距 */
  .beta-welcome-dialog {
    border-radius: var(--vtm-r-lg);

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 20px 24px 24px;
    }
  }
</style>
